import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSetting } from '../../../store/setting/action';

const PurchaseCoinPlan = (props) => {
  const dispatch = useDispatch();
  const { setting } = useSelector((state) => state.setting);

  useEffect(() => {
    dispatch(getSetting());
  }, []);

  return (
    <table className="table table-striped mt-5">
      <thead>
        <tr>
          <th>No.</th>
          <th>User Name</th>
          <th>Diamond</th>
          <th>{`Amount (${setting?.currency?.symbol || '$'})`}</th>
          {/* <th>Rupee</th> */}
          <th>Payment Gateway</th>
          <th>Purchase Date</th>
        </tr>
      </thead>
      <tbody>
        {props?.data?.length > 0 ? (
          props?.data?.map((data, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.name}</td>
                <td className="text-primary">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <img src="/diamond.png" alt="diamond" width="20" height="20" />
                    {data.diamond}
                  </div>
                </td>
                <td className="text-info">{data.dollar} {setting?.currency?.symbol}</td>
                {/* <td className="text-success">{data.rupee}</td> */}
                <td className="text-danger">{data.paymentGateway}</td>
                <td>{data.purchaseDate}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="7" align="center">
              Nothing to show!!
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PurchaseCoinPlan;
